import React, { Component } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import { withNamespaces } from "react-i18next";

//Components
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
import JoinUs from "../../components/JoinUs/JoinUs";

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCtg: 1,
      activePage: 1,
      activeAnimation: true,
      activeProvider: 0,
    };
  }
  
  toggleActiveCtg = (id) => {
    this.removeAnimation(id);
    setTimeout(() => {
      this.setState({ activePage: id, activeAnimation: true });
    }, 1000);
  };

  toggleActiveProdiver = (id) => {
    this.setState({ activeProvider: id });
  };

  removeAnimation = (id) => {
    this.setState({
      activeAnimation: false,
      activeCtg: id,
    });
  };

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;

    const img = this.imageImport(
      require.context(
        "../../assets/images/products",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );
    const icon = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));


    const productCtg = [
      { id: 1, icon: "lc-icon", label: "live-casino" },
      { id: 2, icon: "sports-icon", label: "sports" },
      { id: 3, icon: "esports-icon", label: "esports" },
      { id: 4, icon: "slot-icon", label: "slots" },
      { id: 5, icon: "game-icon", label: "games" },
      { id: 6, icon: "p2p-icon", label: "p2p" },
      { id: 7, icon: "lottery-icon", label: "lottery" },
    ];

    const allProducts = [
      {image: isDesktop ? "products-1.webp" : "products-1-m.webp", title: "products.title-1", description: "products.desc-1", placement: "left", label: "live-casino"},
      {image: isDesktop ? "products-2.webp" : "products-2-m.webp", title: "products.title-2", description: "products.desc-2", placement: "right", label: "sports"},
      {image: isDesktop ? "products-3.webp" : "products-3-m.webp", title: "products.title-3", description: "products.desc-3", placement: "left", label: "esports"},
      {image: isDesktop ? "products-4.webp" : "products-4-m.webp", title: "products.title-4", description: "products.desc-4", placement: "right", label: "slots"},
      {image: isDesktop ? "products-5.webp" : "products-5-m.webp", title: "products.title-5", description: "products.desc-5", placement: "left", label: "games"},
      {image: isDesktop ? "products-6.webp" : "products-6-m.webp", title: "products.title-6", description: "products.desc-6", placement: "right", label: "p2p"},
      {image: isDesktop ? "products-7.webp" : "products-7-m.webp", title: "products.title-7", description: "products.desc-7", placement: "left", label: "lottery"},
    ];

    // Desktop shows all products, mobile shows filtered products based on selected category
    const products = isDesktop ? allProducts : allProducts.filter(product => {
      const selectedCategory = productCtg[this.state.activeProvider];
      return selectedCategory && product.label === selectedCategory.label;
    });

    return (
      <Auxiliary>
        {isDesktop ? (
          <>
          <section
            className="products-section"
          >
            <div className="x-container">
                {products && products.map((product, index) => (
                  <div className="products-wrapper" key={index}>
                    <LazyLoadImage className="product-image" src={img[product.image]} />
                    <div className={`product-details ${product.placement}`}>
                      <h3>{t(product.title)}</h3>
                      <p>{t(product.description)}</p>
                    </div>
                  </div>
                ))}
            </div>
          </section>
          <JoinUs/>
          </>
        ) : (
          <>
          <section className="pf-m-dashboard">
            <MobileSubHeader
              className="bg-white"
              returnPage="/"
              header="Products"
              style={{ justifyContent: "unset" }}
            />
            <div className="mobile-container">
              <div className='game-m-nav mt-2 mb-3 p-3'>
                <div className='row g-2'>
                  {
                    productCtg && productCtg.map((val, idx) => (
                      <div className='col-4' key={val.id}>
                        <div className={`game-nav-btn ${idx === this.state.activeProvider ? "active" : ""}`} onClick={() => this.toggleActiveProdiver(idx)} style={{
                          pointerEvents: ` ${this.state.activeAnimation === false ? "none" : ""}`
                        }}>
                          <img className='nav-img' src={icon[val.icon + ".png"]} alt="" />
                          <p>{t(`about-us.${val.label}`)}</p> 
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
              {products && products.map((product, index) => (
                <div className="products-wrapper" key={index}>
                  <div className={`product-details`}>
                    <h3>{t(product.title)}</h3>
                    <p>{t(product.description)}</p>
                  </div>
                  <LazyLoadImage className="product-image" src={img[product.image]} alt={t(product.title)} />
                </div>
              ))}
              <JoinUs/>
            </div>
          </section>
          </>
        )}
      </Auxiliary>
    );
  }
}

export default (withNamespaces("translation")(Products));
